import React, {FC, FormEvent, ReactNode, useEffect, useState} from 'react'
import {
    Button, Modal,
    ModalFooter as Footer,
    ModalBody as Body,
    ModalHeader as Header,
    ModalTitle as Title, ModalDialog,
} from 'react-bootstrap'
import LoadingButton from "../Button/LoadingButton";
import {useTranslation} from "react-i18next";
import FormEmpty from "../../Vendor/Components/FormEmpty";
import {FormErrors} from "../../Vendor/Components/Form";
import {Method} from "axios";
import {ButtonVariant} from "react-bootstrap/types";

export type FormEmptyModalProps = {
    i18nTitle: string
    show: boolean
    handleClose: () => void
    placement?: 'start' | 'end'
    i18nActionLabel?: string
    isLoading?: boolean
    setIsLoading?: (isLoaded: boolean) => void
    onExited?: () => void
    onSubmit?: (e?: FormEvent<HTMLFormElement>) => void | boolean
    onSuccess?: (data: any) => void
    onError?: (errors?: FormErrors) => void
    onResponse?: (response?: any) => void
    path: string
    method?: Method
    formPath?: boolean|string
    customHeader?: ReactNode
    actionVariant?: ButtonVariant
}

const FormEmptyModal: FC<FormEmptyModalProps> = ({
                                                   i18nTitle,
                                                   show,
                                                   handleClose,
                                                   placement = "end",
                                                   i18nActionLabel,
                                                   isLoading = false,
                                                   setIsLoading,
                                                   onExited,
                                                   onSubmit,
                                                   onResponse,
                                                   customHeader,
                                                   actionVariant,
                                                   ...rest
                                               }) => {
    const {t} = useTranslation()
    const [isLoaded, setIsLoaded] = useState<boolean>(false)
    const [isLocalLoading, setIsLocalLoading] = useState<boolean>(false)
    const [isValidate, setIsValidate] = useState<boolean>(false)

    useEffect(() => {
        setIsLocalLoading(isLoading)
    }, [isLoading])

    useEffect(() => {
        if (setIsLoading) {
            setIsLoading(false)
        } else {
            setIsLocalLoading(false)
        }

        setIsLoaded(false)

        setIsValidate(false)
    }, [show, setIsLoading])

    const localOnSubmit = (e?: FormEvent<HTMLFormElement>) => {
        if (setIsLoading) {
            setIsLoading(true)
        } else {
            setIsLocalLoading(true)
        }

        if (onSubmit) {
            onSubmit(e)
        }
    }

    const localOnResponse = () => {
        setIsLoading ? setIsLoading(false) : setIsLocalLoading(false)
        onResponse && onResponse()
    }

    return <Modal show={show} onHide={handleClose} centered onExited={onExited} enforceFocus={false}>
        <Header closeButton>
            <Title>{t(i18nTitle)}</Title>
        </Header>
        <FormEmpty formContent={{className: 'modal-body'}} {...rest} onResponse={localOnResponse} onSubmit={localOnSubmit} setIsLoaded={setIsLoaded}>
            <Footer>
                <Button variant="secondary" onClick={handleClose}>
                    {t('app.close')}
                </Button>
                <LoadingButton type="submit" isLoading={isLocalLoading} disabled={!isLoaded} variant={actionVariant}>
                    {t(i18nActionLabel ? i18nActionLabel : 'app.validate')}
                </LoadingButton>
            </Footer>
        </FormEmpty>
    </Modal>
}

export default FormEmptyModal
